module.exports = {
  id: 'bookingForm',
  method: 'post',
  action: '/actions/futurium/forms/booking-inquiry',
  labelWidth: 220,
  cells: [
    {
      fieldType: 'infoText',
      copy: '<h2>Booking Enquiry</h2>'
    },
    {
      fieldType: 'infoText',
      copy: '<p>Are you planning an event at Futurium? Before we can confirm your booking, we have to ensure that the nature of your event is aligns with the Futurium’s mission: <b>education, research, science</b>, or a <b>relevant aspect of the future.</b>.<br><br>For further information, please write to <a href="mailto:vermietung@futurium.de">vermietung@futurium.de</a> or call: +49 (0)30 408 18 97-93 or -95.</p>'
    },
    {
      fieldType: 'infoText',
      copy: '<h3>CONTACT DETAILS</h3>'
    },
    {
      fieldType: 'input',
      name: 'organizer',
      label: 'Organizer',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'address',
      label: 'Address',
      required: true
    },
    {
      modifier: 'quarter',
      fieldType: 'input',
      name: 'zip',
      label: 'Postcode',
      required: true
    },
    {
      modifier: 'quarter',
      fieldType: 'input',
      name: 'city',
      label: 'Town/City',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'department',
      label: 'Department'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'position',
      label: 'Position'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'lastName',
      label: 'Surname',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'firstName',
      label: 'First name',
      required: true
    },
    {
      fieldType: 'input',
      name: 'email',
      type: 'email',
      label: 'Email address',
      required: true
    },
    {
      fieldType: 'infoText',
      copy: '<h4>If applicable: agency appointed by the organizer*</h4>'
    },
    {
      fieldType: 'input',
      name: 'agencyNameFull',
      label: 'Agency',
      placeholder: 'Appointed Agency/Contractor'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'agencyAddress',
      label: 'Address'
    },
    {
      modifier: 'quarter',
      fieldType: 'input',
      name: 'agencyZip',
      label: 'Postcode'
    },
    {
      modifier: 'quarter',
      fieldType: 'input',
      name: 'agencyCity',
      label: 'Town/City'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'agencyLastName',
      label: 'Surname'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'agencyFirstName',
      label: 'First Name'
    },
    {
      fieldType: 'input',
      name: 'agencyEmail',
      type: 'email',
      label: 'Email Address'
    },
    {
      fieldType: 'infoText',
      copy: '<h3>EVENT DETAILS</h3><p>Futurium can be booked for half a day (5 hours) or a full day (10 hours). Longer periods of use are possible by arrangement. Please specify a date for the event.</p>'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      type: 'date',
      name: 'desiredDate',
      label: 'Preferred date',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      type: 'date',
      name: 'altDate',
      label: 'Alternative date'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      type: 'time',
      name: 'startTime',
      label: 'Start of the event',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      type: 'time',
      name: 'endTime',
      label: 'End of the event',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      type: 'number',
      name: 'participants',
      label: 'Number of participants',
      required: true,
      min: 1
    },
    {
      fieldType: 'input',
      name: 'room',
      label: 'Preferred Room',
      placeholder: 'Forum, Studio, Foyer…',
      required: true
    },
    {
      fieldType: 'input',
      name: 'eventTitle',
      label: 'Title',
      placeholder: 'Title of the planned event',
      required: true
    },
    {
      fieldType: 'input',
      name: 'eventFormat',
      label: 'Format',
      placeholder:
        'e.g. conference, workshop, product presentation, anniversary celebration, press conference, etc',
      required: true
    },
    {
      fieldType: 'input',
      name: 'partners',
      label: 'Partners',
      placeholder: 'Project exectution organisation(s) / Cooperation partner(s)'
    },
    {
      modifier: 'half',
      fieldType: 'select',
      name: 'hasVips',
      label: 'High Profile Visitors',
      options: [
        { value: 'no', text: 'no' },
        { value: 'yes', text: 'yes' }
      ]
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'vipsDetails',
      label: 'Who? Security measures?',
      placeholder: 'Who is expected? May they require special security measures?'
    },
    {
      modifier: 'half',
      fieldType: 'select',
      name: 'isPublic',
      label: 'Public event',
      options: [
        { value: 'no', text: 'no' },
        { value: 'yes', text: 'yes' }
      ]
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'targetAudience',
      label: 'Target audience',
      placeholder: 'What is the target audience for the event?'
    },
    {
      fieldType: 'infoText',
      copy: '<h3>BRIEF DESCRIPTION OF THE EVENT</h3><p>The theme of your planned event must align with the Futurium’s mission. Please explain the connection to Futurium as you see it and briefly describe the event.</p><h4>Relevance</h4>'
    },
    {
      fieldType: 'checkbox',
      name: 'topic_bildung',
      label: 'Education'
    },
    {
      fieldType: 'checkbox',
      name: 'topic_forschung',
      label: 'Research'
    },
    {
      fieldType: 'checkbox',
      name: 'topic_wissenschaft',
      label: 'Science'
    },
    {
      fieldType: 'checkbox',
      name: 'topic_zukunft',
      label: 'Aspect of the future'
    },
    {
      fieldType: 'textarea',
      name: 'description',
      label: 'Brief description and explanation of the planned event (max. 2500 characters)',
      required: true
    },
    {
      fieldType: 'checkbox',
      name: 'newsletterConsent',
      label:
        'I accept that my personal data may be used for information emails from Futurium’s Event Hire department. I may withdraw my consent at any time. <a href="/en/privacy" target="_blank">By submitting, I agree to Futurium\'s privacy policy</a>',
      required: true
    },
  ],
  submitText: 'Submit Booking Inquiry'
};
